import type { FormFieldData } from '@mobileTypes'

const DEFAULT_FORM_FIELD_DATA: FormFieldData = {
  code: '',
  title: '',
  value: '',
  objectCode: '',
  variableName: '',
  variableObjectCode: '',
  valueType: 'string',
  bindType: 'field',
  embeddedObjectCode: null,
  objectValue: null,
  formCode: '',
  pathArray: null,
  formatDate: null,
  valueFormat: null,
  objectFormCode: null,
  objectFormTitle: null,
  params: null,
  type: 'single',
  userRequired: false,
  defaultRequired: false,
  editField: true,
  isMultiline: false,
  isAddFieldValues: false,
  isEnabledTimeMenu: false,
  fieldValues: [],
  dropDownList: null,
  dropDownWindow: null,
  isDefaultPlaceholder: true,
  placeholderValue: '',
  dropDownListFilters: [],
  dropDownWindowFilters: [],
  preFill: null,
  generalFilterField: null,
}

/** Returns default FormFieldData with optional overrides (e.g. from ElementConfig). */
export function getDefaultFormFieldData(
  overrides?: Partial<FormFieldData>
): FormFieldData {
  return { ...DEFAULT_FORM_FIELD_DATA, ...overrides }
}
